/** @jsxImportSource @emotion/react */
import { DownOutlined } from "@ant-design/icons";
import { css } from "@emotion/react";
import { Button, Dropdown, Menu } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import head from "src/assets/user/head.png";
import { companyServiceHttpClient } from "src/common/CompanyServiceHttpClient";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";
import { LoginUser } from "src/models/loginUser";

export default React.memo(function Login() {
  const formatMessage = useFormatMessage();
  const [user, setUser] = useState(null as LoginUser | null);

  const onClick = useCallback(async () => {
    if (user) {
      await companyServiceHttpClient.oidcClient.signoutRedirect();
      await setUser(null);
    }
  }, [user]);

  let isUnmounted = false;
  const updateUser = useCallback(async () => {
    const user = await companyServiceHttpClient.oidcClient.getUser();
    if (!isUnmounted) {
      if (user) {
        const username = user?.profile as unknown as LoginUser;
        await setUser(username);
      } else {
        return null;
      }
    }
  }, [isUnmounted]);

  useEffect(() => {
    updateUser();
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      isUnmounted = true;
    };
  }, [updateUser]);

  const menu = useMemo(
    () => (
      <Menu onClick={onClick}>
        <Menu.Item key="loginout">
          {formatMessage(messageIds.common.loginOut)}
        </Menu.Item>
      </Menu>
    ),
    [formatMessage, onClick]
  );
  return (
    <div>
      <img
        alt=""
        src={head}
        css={css`
          width: 32px;
          height: 32px;
          margin-right: 8px;
          border-radius: 50%;
        `}
      />
      <Dropdown overlay={menu}>
        <Button
          css={css`
            padding: 0;
            border: none;
            background: none;
          `}
        >
          {user?.name} <DownOutlined />
        </Button>
      </Dropdown>
    </div>
  );
});
